// extracted by mini-css-extract-plugin
export default {"popoverContainer":"Popover_popoverContainer__g-GeT","popoverTrigger":"Popover_popoverTrigger__tQ8jb","menu":"Popover_menu__GMKBR","icon":"Popover_icon__cmTOn"};